
import {
  TeaConfig,
  IdentityType,
  composeTeaProp,
  AvailableStatus,
  IdentityDescI18n,
  IdentityIntactInfo,
  IdentityDefaultAvatar,
} from '@/enums/identity';
import { defineComponent, computed, watch, reactive } from 'vue-demi';
import identityStore from 'src/store/modules/identity/index';
import { useTikTokAuth, useBAUpgrade } from '@/components/auth/tiktokAuth';
import { getAvatarUrl } from '@/utils/creativeUtil';
import { trackEvent } from '@/tea-tracker';
import { useIdentityHooks } from '@/hooks/global/useIdentityHooks';

export default defineComponent({
  name: 'PopupIdentityList',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      switchPopup: false, // tt4b user有真实tt account，出超链want to switch another tt
      needReload: false,
      skeleton: false,
    });
    const { ownerTikTokAccount, nonFakeAccounts } = useIdentityHooks();

    const actualList = computed(() =>
      nonFakeAccounts.value.map(item => ({
        ...item,
        avatar_icon: {
          ...item.avatar_icon,
          web_uri: getAvatarUrl(item.avatar_icon) || IdentityDefaultAvatar,
        },
        desc:
          item.available_status === AvailableStatus.AVAILABLE
            ? IdentityDescI18n.ttba
            : item.available_status === AvailableStatus.NON_BUSINESS_ACCOUNT
            ? IdentityDescI18n.tt
            : '',
        // 只有 绑定授权的TT账号 才能upgrade TTBA & 授权更新，单post授权的TT账号 不能
        // 注意账号可能既需要upgrade也需要authorize
        upgrade:
          item.identity_type === IdentityType.TT_USER && item.available_status === AvailableStatus.NON_BUSINESS_ACCOUNT,
        authorize:
          item.identity_type === IdentityType.TT_USER &&
          (item.available_status === AvailableStatus.SCOPE_UNAVAILABLE ||
            item.available_status === AvailableStatus.NON_VALID_ACCOUNT),
      })),
    );
    const chosenIdentityId = computed(
      () =>
        identityStore.getters.identityFormData.value.curIdentity?.identity_id ??
        identityStore.getters.identityFormData.value?.[0]?.identity_id,
    );
    /**
     * tt4b user 和 绑定授权的TT账号 是一对一关系
     * tt4b user有真实tt account，出超链want to switch another tt；只有单授权post的tt account，出按钮connect a tt account
     */
    const hasActualTT = computed(() => ownerTikTokAccount.value.length !== 0);
    const switchIdentity = (identity: IdentityIntactInfo) => {
      if (identity.available_status !== AvailableStatus.AVAILABLE) {
        return;
      }
      identityStore.mutations.setCurIdentity(identity);
      emit('change-identity', identity);
    };
    const handleIdentityList = async () => {
      state.skeleton = true;
      const identityList = await identityStore.actions.getIdentityList();
      identityStore.mutations.setIdentityList(identityList);
      state.skeleton = false;
    };
    const handleReconnectTikTok = async () => {
      try {
        state.skeleton = true;
        const identityList = await identityStore.actions.getIdentityList();
        identityStore.mutations.setIdentityList(identityList);
        emit('change-identity', identityList[0]);
        state.skeleton = false;
      } catch (e) {
        console.log(e);
      }
    };
    const hidePopup = () => {
      emit('hide', state.needReload);
    };

    /** 企业号升级 */
    const upgrade = () => {
      useBAUpgrade(() => {
        state.needReload = true;
        // root.$toast(root.$t('fastcreation_identity_list_upgrade_success'))
        hidePopup();
        trackEvent('adp_waplite_impression', {
          [TeaConfig.TTBA_UPGRADE.SUCCESS]: 'succeed',
        });
      });
    };

    /**
     * TT identity授权不完善需要去授权
     * 由于没法携带tt登录态，可能出现当前user绑定的是TT账号A，但是当前浏览器登录的是TT账号B，授权失败的场景
     */
    const authorize = () => {
      // todo-kad 这里是否需要一个授权失败的提示文案
      useTikTokAuth(() => {
        handleReconnectTikTok();
        trackEvent('adp_waplite_impression', {
          [TeaConfig.TT_ANOTHER_AUTH.SUCCESS]: 'succeed',
        });
      }, false);
    };

    // todo-kad 这里授权完成流程上有木有啥坑，待确认
    const connectTikTok = () => {
      useTikTokAuth(handleReconnectTikTok);
    };

    watch(
      () => props.show,
      show => {
        if (!show) {
          return;
        }
        state.switchPopup = false;
        state.needReload = false;
        handleIdentityList();
      },
    );

    return {
      state,
      props,
      upgrade,
      TeaConfig,
      hidePopup,
      authorize,
      actualList,
      hasActualTT,
      connectTikTok,
      switchIdentity,
      composeTeaProp,
      chosenIdentityId,
      handleReconnectTikTok,
    };
  },
});
